import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'react-bootstrap';
import snakecaseKeys from 'snakecase-keys';
import _ from 'helpers/no_conflict_lodash';

import TaskForm from 'components/tasks/task_form';

export default class NewCallListModal extends React.Component {
  static propTypes = {
    availableDatabases: PropTypes.array.isRequired,
    currentUser: PropTypes.shape({
      id: PropTypes.number.isRequired,
      marketingListingsAccess: PropTypes.bool
    }).isRequired,
    databaseMembers: PropTypes.array.isRequired,
    defaultAssociatedModels: PropTypes.array.isRequired,
    selectedContacts: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      unloaded: PropTypes.bool
    })).isRequired,
    shown: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
  };

  render() {
    const { shown, selectedContacts, onCancel } = this.props;
    return (
      <Modal backdrop="static" className="bulk-tasks-modal" show={shown} onHide={onCancel}>
        <Modal.Header closeButton>
          <Modal.Title>Create Call List from {selectedContacts.length} Contacts</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderTaskForm()}
        </Modal.Body>
      </Modal>
    );
  }

  renderTaskForm() {
    const {
      availableDatabases,
      currentUser,
      defaultAssociatedModels,
      selectedContacts,
      databaseMembers,
      onCancel,
      onSubmit
    } = this.props;

    const defaultAssignee = snakecaseKeys(databaseMembers.find(member => member.id === currentUser.id) || {});
    const [unloaded, loaded] = _.partition(selectedContacts, contact => contact.unloaded);

    let selected = loaded.map(contact => contact.name).join(', ');

    if (unloaded.length > 0) {
      selected += `, and ${unloaded.length} more`;
    }

    return (
      <TaskForm
        assigneeOptions={snakecaseKeys(databaseMembers)}
        availableDatabaseOptions={availableDatabases}
        callListMode="new"
        defaultAssociatedModels={defaultAssociatedModels}
        defaultTaskAssignee={defaultAssignee}
        hideByProjectSelect={!currentUser.marketingListingsAccess}
        hideContactSelect
        hideProjectSelect={!currentUser.marketingListingsAccess}
        providedTitle="Call with [{Contact}]"
        saveButtonLabel="Create Call List"
        selectedContacts={selected}
        showAssociationToggle
        onCancel={onCancel}
        onSave={onSubmit}
      />
    );
  }
}
